import styled from 'styled-components';

export const Runner = styled.div<{ $left: number; $top: number }>`
  position: fixed;
  left: ${({ $left }) => `${$left}px`};
  top: ${({ $top }) => `${$top}px`};
  z-index: 2000;
  pointer-events: none;
`;
